import {
  Clickable,
  HStack,
  Icon,
  Show,
  Text,
  TextProps,
  ThemeColorTextPath,
  ThemeIconKey,
} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {Nullish, TestIdProps} from 'shared/web';

export interface ParametersItemProps extends TestIdProps {
  title?: string | Nullish;
  icon?: ThemeIconKey;
  variant?: ThemeColorTextPath;
  size?: 'base' | 'small' | 'xSmall';
  alternative?: boolean;
  parametersProps?: TextProps;
  onClick?: (e: React.MouseEvent) => void;
}

export function ParametersItem(props: ParametersItemProps) {
  const variant = props.variant || 'primary';
  const iconColor = `text.${variant}` as `text.${ThemeColorTextPath}`;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    props.onClick?.(e);
  };

  return (
    <Clickable data-testid={props['data-testid']} onClick={handleClick} isDisabled={!props.onClick}>
      <HStack spacing={1} align="center">
        <Show when={isNotNil(props.icon)}>
          <Icon value={props?.icon} size={4} color={iconColor} />
        </Show>
        <Show when={isNotNil(props.title)}>
          <Text
            data-testid={props['data-testid']}
            color={props.variant}
            size={props.size}
            noWrap
            alternative={props.alternative}
            {...props.parametersProps}
          >
            {props.title}
          </Text>
        </Show>
      </HStack>
    </Clickable>
  );
}
